module.exports = __webpack_public_path__ + "media/images/Trash-2-outline-4cf7d1fb.svg";